module.exports = __webpack_public_path__ + "img/ClaveVerde - Full logo.c1c46d26.webp";